import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('#main-content:focus', {
    border: applyColor(DesignTokens.color.utility.focus.default.default, '#3498DB')+' 1px solid',
    boxSizing: 'border-box',
});

cssRule('.tb-vizviewer', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#f5f5f5'),
});

cssRule('.tb-vizviewer.tb-viz-with-info-bar', {
    position: 'absolute',
    top: '50px',
    right: 0,
    bottom: '1px',
    left: 0,
});

cssRule('.tb-vizviewer.tb-viz-with-breadcrumb-bar', {
    position: 'absolute',
    top: '0px',
    right: 0,
    bottom: '1px',
    left: 0,
});

